import React, { useState, useEffect } from "react";
import { useAuth } from "../context/contextAuth";
import { useProfile } from "../context/contextProfile";
import { useThemeMode } from "../context/contextTheme";
import { useNavigate, Link } from "react-router-dom";
import Loader3 from "../components/loaders/Loader-3";
import LogoImg from "../assets/img/logo/Save-Logo-Blue-2.png";

export default function SignIn() {
  const { theme, mode } = useThemeMode();
  const { loadingAuth, getSignin } = useAuth();
  const { zoomLevel } = useProfile();
  const [eyeBtn, setEyeBtn] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isRememberMeChecked, setIsRememberMeChecked] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await getSignin({ username, password });

      if (response.error) {
        setError(response.error);
        return;
      }

      if (isRememberMeChecked) {
        localStorage.setItem("rememberMe", "true");
        localStorage.setItem("rememberMeUsername", username);
        localStorage.setItem("authToken", response.token);
      } else {
        localStorage.removeItem("rememberMe");
        localStorage.removeItem("rememberMeUsername");
        sessionStorage.setItem("authToken", response.token);
      }

      navigate(response.mfa_required ? "/mfa" : "/dashboard");

    } catch (error) {
      setError(error.message);
    }
  };

  const eyeIcon = eyeBtn ? "bi bi-eye-slash-fill" : "bi bi-eye-fill";
  const inputType = eyeBtn ? "password" : "text";

  useEffect(() => {
    document.body.style.backgroundImage =
      "radial-gradient(circle at center, #302158, #100021)";
    document.body.style.height = "100vh";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";
  }, [mode, theme.background]);

  useEffect(() => {
    const savedRemember = localStorage.getItem("rememberMe") === "true";
    const savedUsername = localStorage.getItem("rememberMeUsername") || "";
    setIsRememberMeChecked(savedRemember);
    if (savedRemember) setUsername(savedUsername);
  }, []);

  return (
    <div>
      {loadingAuth ? (
        <Loader3 />
      ) : (
        <div className="position-absolute top-50 start-50 translate-middle">
          <div
            className="bg-white rounded-4 shadow-lg p-5"
            style={{
              maxWidth: 420,
              width: "100%",
              transform: `scale(${zoomLevel})`
            }}
          >
            <div className="text-center mb-4">
              <img src={LogoImg} alt="Logo" height={50} />
            </div>

            <div className="text-center mb-4">
              <h4 className="fw-bold text-dark">Sign In</h4>
              <p className="text-secondary small">
                Welcome back! Please enter your details.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="form-label fw-semibold small">
                  Username
                </label>
                <input
                  type="text"
                  className="form-control rounded-3 bg-light"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="john.doe"
                  required
                />
              </div>

              <div className="mb-4 position-relative">
                <label className="form-label fw-semibold small">
                  Password
                </label>
                <input
                  type={inputType}
                  className="form-control rounded-3 bg-light pe-5"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  className="btn position-absolute top-50 end-0 my-3 translate-middle-y border-0 bg-transparent text-secondary"
                  onClick={() => setEyeBtn(!eyeBtn)}
                >
                  <i className={eyeIcon}></i>
                </button>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-4 small">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isRememberMeChecked}
                    onChange={(e) =>
                      setIsRememberMeChecked(e.target.checked)
                    }
                    id="rememberMe"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="rememberMe"
                  >
                    Remember Me
                  </label>
                </div>

                <Link
                  to="/reset"
                  className="text-decoration-none fw-semibold"
                  style={{ color: "#0ea5e9" }}
                >
                  Forgot Password?
                </Link>
              </div>

              {error && (
                <div className="alert alert-danger py-2 text-center small">
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="btn w-100 fw-bold rounded-3"
                style={{
                  backgroundColor: "#0ea5e9",
                  color: "#fff",
                  padding: "12px"
                }}
              >
                Sign In
              </button>

              {/* Footer */}
              {/* <div className="text-center mt-4 small text-secondary">
                Not a member yet?{" "}
                <Link
                  to="/signup"
                  className="fw-bold text-decoration-none"
                  style={{ color: "#0ea5e9" }}
                >
                  Sign Up
                </Link>
              </div> */}
            </form>
          </div>
        </div>
      )}
    </div>
  );
}